import { render, staticRenderFns } from "./ElementVideo.vue?vue&type=template&id=67e5e8b0&"
import script from "./ElementVideo.vue?vue&type=script&lang=js&"
export * from "./ElementVideo.vue?vue&type=script&lang=js&"
import style0 from "./ElementVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
